import BaseParagraph from "../../baseComponents/baseParagraph";
import BaseButton from "../../baseComponents/baseButton";

import LoginTemplate from "../loginStack/LoginTemplate.js";
import { useEffect, useRef } from "react";
import { actions as loginActions } from "../../store/slices/loginSlice.js";
import { useDispatch, useSelector } from "react-redux";

const TokenExpiredView = ({}) => {
  /////////////////////////////////////////////dispatcher
  const dispatch = useDispatch();

  /////////////////////////////////////////////refs
  const mainButtonRef = useRef();

  /////////////////////////////////////////////methods

  const goBackToRoot = () => {
    dispatch(loginActions.logout());
    window.location.href = "/";
  };

  /////////////////////////////////////////////styles
  const styles = {
    errorContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },

    errorTitle: {
      fontSize: "40px",
      textAlign: "center",
      marginBottom: "0.5em",
    },
    errorMessage: {
      fontSize: "24px",
      textAlign: "center",
      marginBottom: "0.5em",
    },
    button: {
      paddingLeft: "1em",
      paddingRight: "1em",
      paddingTop: "0.5em",
      paddingBottom: "0.5em",
    },
  };

  /////////////////////////////////////////////effects
 

  /////////////////////////////////////////////render
  return (
    <LoginTemplate showPickers={false} icon={null} autoRelogin={false} focusElement={mainButtonRef}>
      <div style={styles.errorContainer}>
        <BaseParagraph>tokenExpired</BaseParagraph>
        <BaseButton
          style={styles.button}
          onClick={goBackToRoot}
          innerRef={mainButtonRef}
          translate
        >
          homePage
        </BaseButton>
      </div>
    </LoginTemplate>
  );
};

export default TokenExpiredView;
